/**
 * @pageName Products
 * @slotType dashboard plugin
 */
export type ProductsBannerParams = {};
/**
 * @pageName Products
 * @slotType dashboard menu plugin
 */
export type ProductsMainMoreActionsMenuParams = {};

/**
 * @pageName Products
 * @slotType dashboard menu plugin
 */
export type ProductItemMoreActionsMenuParams = MenuSingleItem;
/** @internal */
export interface MenuSingleItem {
  // Product ID.
  id: string;
}
/**
 * @pageName Products
 * @slotType dashboard menu plugin
 */
export type ProductItemsBulkMoreActionsMenuParams = {};
